/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import {
  GET_CIRCULARS_REQUEST,
  GET_CIRCULARS_SUCCESS,
  GET_CIRCULARS_FAILURE,
  CREATE_CIRCULAR_REQUEST,
  CREATE_CIRCULAR_SUCCESS,
  CREATE_CIRCULAR_FAILURE,
  UPDATE_CIRCULAR_REQUEST,
  UPDATE_CIRCULAR_SUCCESS,
  UPDATE_CIRCULAR_FAILURE,
  DELETE_CIRCULAR_REQUEST,
  DELETE_CIRCULAR_SUCCESS,
  DELETE_CIRCULAR_FAILURE,
} from "./circularTypes";

const initialState = {
  loading: false,
  circulars: {},
  error: "",
};

const getCircularsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CIRCULARS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_CIRCULARS_SUCCESS:
      return {
        loading: false,
        circulars: action.payload,
        error: "",
      };
    case GET_CIRCULARS_FAILURE:
      return {
        loading: false,
        circulars: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForHome = {
  loading: false,
  circularsForHome: {},
  error: "",
};

const getCircularsForHomeReducer = (state = initialStateForHome, action) => {
  switch (action.type) {
    case GET_CIRCULARS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_CIRCULARS_SUCCESS:
      return {
        loading: false,
        circularsForHome: action.payload,
        error: "",
      };
    case GET_CIRCULARS_FAILURE:
      return {
        loading: false,
        circularsForHome: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForCreate = {
  loading: false,
  circular: {},
  error: "",
};

const createCircularReducer = (state = initialStateForCreate, action) => {
  switch (action.type) {
    case CREATE_CIRCULAR_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CREATE_CIRCULAR_SUCCESS:
      return {
        loading: true,
        circular: action.payload,
        error: "",
      };
    case CREATE_CIRCULAR_FAILURE:
      return {
        loading: false,
        circular: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForUpdate = {
  loading: false,
  circular: {},
  error: "",
};

const updateCircularReducer = (state = initialStateForUpdate, action) => {
  switch (action.type) {
    case UPDATE_CIRCULAR_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_CIRCULAR_SUCCESS:
      return {
        loading: true,
        circular: action.payload,
        error: "",
      };
    case UPDATE_CIRCULAR_FAILURE:
      return {
        loading: false,
        circular: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForDelete = {
  loading: false,
  circular: {},
  error: "",
};

const deleteCircularReducer = (state = initialStateForDelete, action) => {
  switch (action.type) {
    case DELETE_CIRCULAR_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_CIRCULAR_SUCCESS:
      return {
        loading: true,
        circular: action.payload,
        error: "",
      };
    case DELETE_CIRCULAR_FAILURE:
      return {
        loading: false,
        circular: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

export {
  getCircularsReducer,
  getCircularsForHomeReducer,
  createCircularReducer,
  updateCircularReducer,
  deleteCircularReducer,
};
